import React from "react"

import { ButtonPrimary } from "../../../../../clux-ui/components"
import { ITEM_TYPES } from "../../config/constants"
import { DetectiveCluxConfig, Suspects } from "../../config/interfaces"
import SpeechBubble from "../SpeechBubble"
import Tile from "../Tile"

import "./style.scss"

interface ResultatsProps {
  background: string
  images: Pick<DetectiveCluxConfig["images"], "detective" | "roi">
  messages: DetectiveCluxConfig["messages"]
  isSolved: boolean
  solution: Suspects
  onRestart: () => void
  onQuit: () => void
}

/** Étape des résultats : verdict du roi, et solution révélée en cas d'échec */
const Resultats = ({
  background,
  images,
  messages,
  isSolved,
  solution,
  onRestart,
  onQuit,
}: ResultatsProps) => (
  <div
    className="dc-resultats"
    style={{ backgroundImage: `url(${background})` }}
  >
    <div className="dc-resultats__panel">
      <h1 className="dc-resultats__title">
        {isSolved ? "Enquête résolue !" : "Enquête non résolue"}
      </h1>

      <div className="dc-resultats__characters">
        <img
          className="dc-resultats__character"
          src={images.detective}
          alt="Le détective Clux"
        />
        <SpeechBubble
          image={images.roi}
          speaker="Le roi"
          message={isSolved ? messages.roiSucces : messages.roiEchec(solution)}
          isReversed
        />
      </div>

      {!isSolved && (
        <section aria-labelledby="dc-resultats-solution">
          <h2 id="dc-resultats-solution" className="dc-resultats__subtitle">
            La solution
          </h2>
          <ul className="dc-resultats__solution">
            {ITEM_TYPES.map(type => (
              <li key={type}>
                <Tile item={solution[type]} />
              </li>
            ))}
          </ul>
        </section>
      )}

      <div className="dc-resultats__actions">
        {!isSolved && (
          <ButtonPrimary onClick={onRestart}>Rejouer</ButtonPrimary>
        )}
        <ButtonPrimary onClick={onQuit}>Quitter</ButtonPrimary>
      </div>
    </div>
  </div>
)

export default Resultats
